import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { connect } from 'react-redux';
import { mapState } from '@deerplusofficial/pos-helper';
import {
  Button,
  BarcodeScanner,
  QrCodeScanner,
  EmbedScanner,
  Icon,
} from '@deerplusofficial/pos-components';
import styled from 'styled-components';
import actions from '../../actions';

export const types = [
  {
    type: 'embed',
    name: '外接掃碼器',
    icon: 'scanner',
    scanner: EmbedScanner,
  },
  {
    type: 'barcode',
    name: 'Barcode',
    icon: 'barcode-read',
    scanner: BarcodeScanner,
  },
  {
    type: 'qrcode',
    name: 'QR Code',
    icon: 'qrcode',
    scanner: styled(QrCodeScanner)`
      width: 100%;
      max-width: 320px;
      margin: 0 auto;
    `,
  },
];

const Container = styled(Button).attrs({ primary: true })``;

const ScannerIcon = styled(Icon).attrs({ size: '3x' })`
  margin: 4px auto 12px;
`;

class ScannerSelectorButton extends React.PureComponent {
  static propTypes = {
    type: PropTypes.oneOf(_.map(types, ({ type }) => type)),
  };

  static defaultProps = {
    type: undefined,
  };

  onClick = () => {
    const { type, scanner, changeScannerType, onClick } = this.props;

    if (type === scanner.type) return;

    changeScannerType(type);
    onClick();
  };

  render() {
    const { type, icon, scanner, title } = this.props;

    return (
      <Container highlight={type === scanner.type} onClick={this.onClick}>
        <div>
          <ScannerIcon icon={icon} />
        </div>
        {title}
      </Container>
    );
  }
}

const {
  type: { change: changeScannerType },
} = actions.scanner;

export default connect(
  mapState(['scanner']),
  { changeScannerType }
)(ScannerSelectorButton);



// WEBPACK FOOTER //
// ./src/components/ScannerSelector/ScannerSelectorButton.js